module.exports = __webpack_public_path__ + "img/3.a67d465e.png";